/** The firm operates on Tashkent time; period boundaries are stored in UTC. */
export const BILLING_PERIOD_TZ = 'Asia/Tashkent';

/**
 * Render a billing-period boundary as a local calendar date (`dd-mm-yyyy`).
 *
 * Two facts made a plain `dateStr.slice(0, 10)` print the wrong day:
 *  1. the raw ISO string is UTC, while a period means Tashkent (+05) days;
 *  2. generated periods chain `startDate = previous period's endDate`, so every
 *     period after the first is stored as the *last instant before* it opens
 *     (`2026-06-30T18:59:59.999Z` for the period that runs 01.07–31.07).
 *
 * Passing `isStart` adds back the 1 ms the chaining subtracts, so the label lands
 * on the true first day. End dates are already the last instant of their own day
 * and are formatted as-is.
 *
 * Display only — stored boundaries are untouched. Defect AL-2026/08-03-01, D-05.
 */
export function formatBillingPeriodDate(
  dateStr?: string | null,
  isStart = false,
): string {
  if (!dateStr) return '';
  const dt = new Date(dateStr);
  if (isNaN(dt.getTime())) return '';
  const shown = isStart ? new Date(dt.getTime() + 1) : dt;
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: BILLING_PERIOD_TZ,
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
    .format(shown)
    .replace(/\//g, '-');
}
